import { TypeDiffusionEnum } from '../../../../../models/enums/type-diffusion.enum';
import cloneDeep from 'lodash.clonedeep';
import { Preference } from './../../model/preference';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Diffuseur } from '../../../../../models/diffuseur';
import { Endpoints } from '../../../../../models/endpoints';
import { DepartementMapper } from '../../../../../models/enums/zone-geographique.enum';
import { TableContent } from '../../../../shared/generic/components/tableau/model/table.content';
import { ChoixSupportMessages } from '../../../../shared/models/component-messages/choix-supports-messages';
import { HttpService } from '../../../../shared/services/http.service';
import { DiffuseurItem } from '../../../creer/models/diffuseur.item';
import * as jsonColsChoixDiff from '../../../../../../assets/dynamic/support/tableCols.json';
import { Router, ActivatedRoute } from '@angular/router';
import { PreferenceMessages } from '../../../../shared/models/component-messages/preference-messages';
import { PreferencesService } from '../../services/preferences.service';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Constants } from '../../../../shared/generic/models/constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InformationComponent } from '../../../../shared/modals/information/information.component';
import { PreferenceType } from '../../../../shared/models/enum/preferenceType';
import { SessionService } from '../../../../administration/services/session.service';
import { environment } from '../../../../../../environments/environment';

@Component({
  templateUrl: './preference-diffuseur-detail.component.html',
  styleUrls: ['./preference-diffuseur-detail.component.scss']
})
export class PreferenceDiffuseurDetailComponent implements OnInit, OnDestroy {

  public tableContent: TableContent = new TableContent();

  action: string;
  id: string;
  chargeTableau = false;

  private unsubscribe$ = new Subject<void>();

  form: FormGroup;
  myForm: FormGroup;

  public choixSupport = new ChoixSupportMessages();
  public preferenceMessages = new PreferenceMessages();

  allDatasDiffuseurs: Diffuseur[] = [];

  diffuseursList: Diffuseur[] = [];
  diffuseursListOriginal: Diffuseur[] = [];

  preference: Preference;

  constructor(private http: HttpService, private modalService: NgbModal, private router: Router, private route: ActivatedRoute, private preferenceService: PreferencesService, private session: SessionService) {
  }

  ngOnInit() {
    this.form = new FormGroup({});
    this.myForm = new FormGroup({});
    this.initParam();
    this.getAllDiffuseurs();

  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  initParam(): void {
    this.action = this.route?.routeConfig?.data?.action;
    if (this.action === 'modifier') {
      this.id = this.route?.snapshot?.paramMap?.get('id');
    }
  }

  getPreference() {
    this.preferenceService.getByIdDiffuseur(this.id).pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((data) => {
          this.preference = data;
          data.content.values.forEach(e => {
            this.diffuseursList.push(this.findDiffuseur(Number(e.value)));
          });
          this.diffuseursListOriginal = cloneDeep(this.diffuseursList);
          this.myForm.get('preference_SepAtt_diffuseur_SepAtt_intitule')?.setValue(this.preference.titre);
          this.setTableContent();
        })
      });
  }

  getZoneGeo(item: Diffuseur): string {
    const res: string = DepartementMapper.getIntitule(String(item?.zoneGeographique));
    return res?.substring(0, res.indexOf(' '));
  }

  getAllDiffuseurs(): void {
    this.preferenceService.getAllDatasDiffuseurs().pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((data) => {
          this.allDatasDiffuseurs = data;
          if (this.action === 'ajouter') {
            this.setTableContent();
          }
          if (this.action === 'modifier') {
            this.getPreference();
          }
        })
      });
  }

  getActionOnTab(event) {
    this.diffuseursList = [];
    Object.keys((event.controls.tableDataCtrlName as FormGroup).controls).forEach(key => {
      const diffFormGrp: any = this.form.get(Constants.TABLE_DATA_CTRL_NAME);
      const diffsCtrl: any = diffFormGrp.controls;
      if (diffsCtrl[key].controls.checked.value && !key.includes('p')) {
        this.diffuseursList.push(this.findDiffuseur(Number(key)));
      }
    });
  }

  partageReturn(event) {
    if (event.type === PreferenceType.DIFFUSEURS) {
      this.router.navigate([location.pathname + '/' + event.id]);
    } else {
      this.router.navigate(['/preferencesAvisPub']);
    }
  }

  getLabelEtiquette(item: any): string {
    let res = '';
    if (item?.typeFlux !== 'PRESSE_SPE') {
    if (item?.typeFlux === 'JOUE' || item?.typeFlux === 'BOAMP') {
      res = res.concat(item?.support != '' ? item?.support + ' - ' : String(item?.typeZone));
    }
    else {
      res = res.concat(item?.support != '' ? item?.support + ' - ' : String(item?.typeZone) + ' - ');
      res = res.concat(this.getZoneGeo(item));
    }
      if (String(item?.typeSupport) != 'AUCUN') {
        res = res.concat(' - ' + String(item?.typeSupport));
      }
    } else {
      res = res.concat(item?.intitule);
      if (this.getZoneGeo(item) !== '') {
        res = res.concat(' - ' + this.getZoneGeo(item));
      }
    }
    return res;
  }

  setTableContent(): void {
    const tblCont = new TableContent();
    tblCont.displayedCols = ['develop', 'checkbox', 'zonediffusion', 'diffuseur', 'format', 'action'];
    tblCont.expandedColumn = ['develop', 'checkbox', 'zonediffusion', 'diffuseur', 'format', 'action'];
    tblCont.uniqueKey = 'zonediffusion';
    tblCont.tableCols = jsonColsChoixDiff.table;
    tblCont.tableChildCols = jsonColsChoixDiff.table;
    const prefIds: number[] = [];
    this.diffuseursList.forEach(e => {
      prefIds.push(Number(e?.id));
    });
    this.http.get(Endpoints.DIFFUSEUR_FINDALL
      + Endpoints.DIFFUSEUR_SIRET
      + this.session.getUser()?.siret
      + Endpoints.DIFFUSEUR_SERVICE
      + this.session.getUser()?.service).subscribe((data) => {
        const diffuseurs = Object.keys(data).map(index => {
          if (environment.shal_enabled === "false" && (data[index].typeFlux?.toString() === 'SHAL' || data[index].typeFlux?.toString() === 'PRESSE_SPE')) {
            return;
          }
          const diffuseur: Diffuseur = data[index];
          const diffuseurItem: DiffuseurItem = new DiffuseurItem();
          diffuseurItem.id = diffuseur.id.toString();
          if (prefIds.includes(Number(diffuseurItem.id))) {
            diffuseurItem.checked = true;
          }
          diffuseurItem.support = diffuseur.support;
          if (diffuseur.typeZone?.toString() === 'EUROPE') {
            diffuseurItem.zonediffusion = diffuseur.typeZone.toString();
            diffuseurItem.diffuseur = 'JOUE';
            // a changer quand le support sera changer en base
            diffuseurItem.support = 'JOUE';
          } else if (diffuseur.typeZone?.toString() === 'NATIONAL') {
            diffuseurItem.zonediffusion = diffuseur.typeZone.toString();
            diffuseurItem.diffuseur = 'BOAMP';
            // a changer quand le support sera changer en base
            diffuseurItem.support = 'BOAMP';
          } else {
            diffuseurItem.zonediffusion = diffuseur.zoneGeographique.toString();
            diffuseurItem.diffuseur = diffuseur.support;
          }
          if (diffuseur.typeZone === null) {
            diffuseurItem.support = diffuseur.intitule;
            diffuseurItem.zonediffusion = diffuseur.zoneGeographique.toString();
            diffuseur.typeSupport = TypeDiffusionEnum.PRESSE_SPE;
          }
          diffuseurItem.format = diffuseur.typeSupport + '';
          return diffuseurItem;
        }).filter(data => data);

        let tempTable: DiffuseurItem[] = [];
        const deps = diffuseurs.filter((diff) => {
          return diff.zonediffusion !== 'EUROPE' && diff.zonediffusion !== 'NATIONAL';
        });

        this.sortDiff(deps).forEach((diff2) => {
          if (diff2.zonediffusion.includes('D_')) {
            if (this.isDepartementExistant(tempTable, DepartementMapper.getIntitule(diff2.zonediffusion))) {
              tempTable.forEach((e) => {
                if (e.zonediffusion?.includes(DepartementMapper.getIntitule(diff2.zonediffusion))) {
                  if (e.children.length > 0) {
                    const diffParent = diff2;
                    diffParent.idParent = e.id;
                    diffParent.zonediffusion = DepartementMapper.getIntitule(diff2.zonediffusion);
                    e.children.push(diffParent);
                  } else {
                    const tempItem: DiffuseurItem = new DiffuseurItem();
                    tempItem.id = e.id + 'p';
                    tempItem.diffuseur = '';
                    tempItem.format = '';
                    tempItem.support = '';
                    tempItem.zonediffusion = DepartementMapper.getIntitule(diff2.zonediffusion);
                    tempItem.develop = true;
                    tempItem.children.push(e);
                    const diffParent = diff2;
                    diffParent.idParent = e.id + 'p';
                    diffParent.zonediffusion = DepartementMapper.getIntitule(diffParent.zonediffusion);
                    tempItem.children.push(diffParent);
                    tempTable[tempTable.indexOf(e)] = tempItem;
                  }
                }
              });
            } else {

              const diffParent = diff2;
              diffParent.idParent = diff2.id + 'p';
              diffParent.zonediffusion = DepartementMapper.getIntitule(diff2.zonediffusion);
              tempTable.push(diffParent);
            }
          }
          if ( diff2.zonediffusion == 'EMPTY'){
            const diffPs = diff2;
            diffPs.idParent = diff2.id + 'p';
            diffPs.zonediffusion = '';
            diffPs.diffuseur = diff2.support;
            tempTable.push(diffPs);
          }
        });

        tempTable.unshift(
          diffuseurs.find((diff) => {
            return diff.zonediffusion === 'EUROPE';
          })
        );
        tempTable.unshift(
          diffuseurs.find((diff) => {
            return diff.zonediffusion === 'NATIONAL';
          })
        );

        tempTable = tempTable.filter(this.notEmpty);
        tempTable.forEach(e => {
          if (prefIds.includes(Number(e.id))) {
            e.checked = true;
          } else {
            e.checked = false;
          }
        });
        tblCont.tableData.next(tempTable);
      },
        error => {
          console.error(error);
        });

    this.tableContent = tblCont;

    this.chargeTableau = true;
  }

  private sortDiff(deps: DiffuseurItem[]) {
    return deps.sort((a, b) => {
      const textA = a.zonediffusion.toUpperCase();
      const textB = b.zonediffusion.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }

  findDiffuseur(id: number): Diffuseur {
    return this.allDatasDiffuseurs?.find(element => element.id === id);
  }

  isDepartementExistant(tab: DiffuseurItem[], dep: string) {
    return !!tab.find((diff) => {
      return diff.zonediffusion.includes(dep.toString());
    });
  }

  notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
    return value !== null && value !== undefined;
  }

  retour(): void {
    this.router.navigate(['/preferencesAvisPub']);
  }

  savePref(): void {
    const prefToSave = new Preference;
    prefToSave.titre = this.myForm.get('preference_SepAtt_diffuseur_SepAtt_intitule')?.value;
    this.diffuseursList.forEach(e => {
      prefToSave.content.values.push({ code: 'idDiffuseur', value: String(e.id) });
    });
    const modalRef = this.modalService.open(InformationComponent);
    modalRef.componentInstance.title = '';
    modalRef.componentInstance.OkOuRetour = true;
    if (this.action === 'ajouter') {
      modalRef.componentInstance.content = this.preferenceMessages.modal_create_text;
      modalRef.dismissed.pipe(map((reason: boolean) => {
        return reason;
      }))
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: ((reason) => {
            if (reason) {
              this.preferenceService.createDiffuseur(prefToSave).pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                  next: (() => {
                    this.retour();
                  })
                });
            }
          })
        });
    }
    if (this.action === 'modifier') {
      prefToSave.id = Number(this.id);
      modalRef.componentInstance.content = this.preferenceMessages.modal_update_text;
      modalRef.dismissed.pipe(map((reason: boolean) => {
        return reason;
      }))
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: ((reason) => {
            if (reason) {
              this.preferenceService.updateDiffuseur(prefToSave).pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                  next: (() => {
                    this.retour();
                  })
                });
            }
          })
        });
    }
  }

  annuler(): void {
    this.myForm.get('preference_SepAtt_diffuseur_SepAtt_intitule')?.setValue(this.preference?.titre);
    this.diffuseursList = this.diffuseursListOriginal;
    this.setTableContent();
  }

  delete(obj: Diffuseur): void {
    this.diffuseursList = this.diffuseursList.filter(item => item !== obj);
    this.setTableContent();
  }

  getActionOnPresse(diffuseur: Diffuseur): void {
    const index = this.allDatasDiffuseurs.findIndex(e => e.id === diffuseur.id);
    if (index === -1) {
      this.allDatasDiffuseurs.push(diffuseur);
    } else {
      if (diffuseur.intitule !== undefined) {
        this.allDatasDiffuseurs[index].contact = diffuseur.contact;
        this.allDatasDiffuseurs[index].email = diffuseur.email;
        this.allDatasDiffuseurs[index].telephone = diffuseur.telephone;
        this.allDatasDiffuseurs[index].intitule = diffuseur.intitule;
        this.allDatasDiffuseurs[index].zoneGeographique = diffuseur.zoneGeographique;
      } else {
        this.allDatasDiffuseurs = this.allDatasDiffuseurs.filter(item => item.id !== diffuseur.id);
        this.diffuseursList = this.diffuseursList.filter(item => item.id !== diffuseur.id);
        this.diffuseursListOriginal = this.diffuseursListOriginal.filter(item => item.id !== diffuseur.id);
      }
    }
    this.setTableContent();
  }

}
